import { axios, API, SendRequest } from '@/imports-files/components/switch-user'
export class UserSwitchServices extends SendRequest {

    async switchRole(params) {
        const url = API.agency.SWITCH_ROLE
        try {
            const result = await axios.get(url,
                {
                    params: params,
                    headers: this.customHeaderJSON()
                },
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
            return result;
        }
        catch (error) {
            return error;
        }
    }

    async getSwitchData(params) {
        const url = API.agency.SWITCH_LIST
        try {
            const result = await axios.get(url,
                {
                    params: params,
                    headers: this.customHeaderJSON()
                },
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
            return result;
        }
        catch (error) {
            return error;
        }
    }
}